import { Injectable } from '@angular/core';
import { ActionAsideMenuOpenClose } from '@global-actions/action-aside-menu/action-aside-menu';
import { Action, State, StateContext } from '@ngxs/store';
@State<ActionAsideMenuOpenClose>({
  name: 'stateAsideMenu',
  defaults: {
    isOpen: false
  }
})
@Injectable()
export class StateAsideMenu {
  constructor() {}
  @Action(ActionAsideMenuOpenClose)
  openCloseMenu(
    ctx: StateContext<ActionAsideMenuOpenClose>,
    action: ActionAsideMenuOpenClose
  ): void {
    ctx.setState({
      ...ctx.getState(),
      isOpen: action.isOpen
    });
  }
}
